import StatusStepper, { customerPortalPurchaseOrderStatuses } from 'src/components/atoms/StatusStepper';
import { AgCollapsibleCard } from 'src/components/ui';
import { ProductsGridSkeleton } from 'src/modules/inventory';

import useCustomerPortalProducts from '../useCustomerPortalProducts';

import LineItemsGrid from './LineItemsGrid';
import OrderDetails from './OrderDetails';
import { CustomerPortalPurchaseOrderData } from './useCustomerPortalPurchaseOrder';

export default function EditCustomerPortalPurchaseOrder({
  purchaseOrder,
}: {
  purchaseOrder: CustomerPortalPurchaseOrderData;
}) {
  const products = useCustomerPortalProducts(purchaseOrder?.id);

  return (
    <div className="flex flex-col gap-4">
      <StatusStepper allStatuses={customerPortalPurchaseOrderStatuses} currentStatus={purchaseOrder.status} />
      <AgCollapsibleCard title="Order Details">
        <OrderDetails purchaseOrder={purchaseOrder} />
      </AgCollapsibleCard>
      <AgCollapsibleCard title="Products">
        {!products ? <ProductsGridSkeleton /> : <LineItemsGrid purchaseOrder={purchaseOrder} products={products} />}
      </AgCollapsibleCard>
    </div>
  );
}
